// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/upload.js';

import { paths } from '../generated/upload';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('upload', Original, paths);
